<template>
  <div style="height: 100%;width:100%;background:#000000;padding:26px">
    <div v-if="isMobile" class="el-icon-location-information" style="color:#ffffff;font-size:15px;position:absolute;top:35px;right:130px;z-index:1">{{project.aio_project_name||project.name}}<img v-if="project['4gstatus']" style="margin-left:10px;height:12px;width:12px" :src='"../../static/images/icon/4g-"+(JSON.parse(project["4gstatus"]).rssiLevel||0)+".png"'/><span style="font-size:12px;margin-left:15px" v-if="project['4gstatus']">当月使用：{{project.flowused}}MB，剩余流量：{{project.flow_left}}MB</span></div>
    <div v-else class="el-icon-location-information" style="color:#ffffff;font-size:15px;position:absolute;top:10px;right:30%;z-index:1">{{project.aio_project_name||project.name}}<img v-if="project['4gstatus']" style="margin-left:10px;height:12px;width:12px" :src='"../../static/images/icon/4g-"+(JSON.parse(project["4gstatus"]).rssiLevel||0)+".png"'/></div>
    <div v-if="!isMobile" style="color:#ffffff;font-size:12px;position:absolute;top:10px;right:8%;z-index:1; border: 1px solid #ccc; padding: 0px 3px; border-radius: 10px;" @click="PC()">电脑版</div>
    <el-dropdown @command="handleCommand" style="position:absolute;top:33px;right:30px;z-index:1;color:#ffffff">
  <span class="el-dropdown-link" >
    菜单<i class="el-icon-arrow-down el-icon--right"></i>
  </span>
  <el-dropdown-menu  slot="dropdown">
    <el-dropdown-item v-if="dealerid" command="pandect">大屏展示</el-dropdown-item>
    <el-dropdown-item command="choose">项目选择</el-dropdown-item>
    <el-dropdown-item command="adminDealer" v-if="userName == 'menred'">经销商管理</el-dropdown-item>
    <el-dropdown-item command="Dealer" v-if="level == 1||level == 2">系统设置</el-dropdown-item>
    <el-dropdown-item command="password" v-if="userName != 'menred'">修改密码</el-dropdown-item>
    <el-dropdown-item command="exit">退出登录</el-dropdown-item>
  </el-dropdown-menu>
</el-dropdown>
    <el-tabs id="devicetab" type="border-card" style="height:calc(100% - 52px); width:calc(100% - 52px);">
      <el-tab-pane label="实况" style="overflow:auto" v-if="project.protocolid===227">
        <router-view v-if="isMobile" style="width:1667px;height:878px;margin:0 auto;" name="real"  :isMobile="isMobile"  />
        <router-view v-else style="width:100%;height:100%;margin:0 auto;" name="real" :isMobile="isMobile" />
      </el-tab-pane>
      <el-tab-pane label="实况" style="overflow:auto" v-else>
        <router-view v-if="isMobile" style="width:1667px;height:878px;margin:0 auto;" name="cch" :isMobile="isMobile" />
        <router-view v-else style="width:1667px;height:878px;margin:0 auto;" name="cch" :isMobile="isMobile"  />
      </el-tab-pane>
      <el-tab-pane label="曲线" v-if="project.protocolid===227"><router-view style="height: 100%;width:100%;"  name="report" :isMobile="isMobile" /></el-tab-pane>
      <el-tab-pane label="曲线" v-else><router-view style="height: 100%;width:100%;"  name="cchreport" :isMobile="isMobile" /></el-tab-pane>
      <el-tab-pane v-if="user.username!='menredxtkt'&&project.demo!=1" label="方案"><router-view style="height: 100%;width:100%;"  name="setup"/></el-tab-pane>
      <el-tab-pane label="日志"><router-view style="height: 100%;width:100%;"  name="log"/></el-tab-pane>
  </el-tabs>
  
  </div>
</template>

<script>
export default {
  name: "Index",
  
  // watch:{
  //   activeIndex(val){
  //       this.handleSelect(val);
  //   }
  // },
  data() {
    return {
      project:{},
      user:{},
      userName: '',
      level: 0,
      dealerid:'',
      isMobile: true,
    };
  },
  mounted: function () {
    var self = this
    if (self.$isMobile()) {
      self.isMobile = false
    } else {
      self.isMobile = true
    }

    //debugger
    let project=window.localStorage.getItem('project')
    if(project){
      this.project=JSON.parse(project)
    }else{
       this.$router.push({ name: "Login" });
       return
    }
    let Username = window.localStorage.getItem("customer")
    self.user = JSON.parse(Username)
    self.userName = self.user.username
    self.dealerid=self.user.dealerid
    self.level = self.user.level
  },
  computed: {
      
  },
  methods: {
    handleCommand(key){
      if(key==='exit'){
        window.localStorage.clear();
        this.$router.push({ name: "Login" });
      }else{
        if(key==='pandect') {
          this.$router.push({ name: "Pandect" });
        }else{
          if(key === 'adminDealer') {
            this.$router.push({ name: "AdminDealer" });
          }else {
            if(key === 'Dealer') {
              if(this.level == 1) {
                this.$router.push({ name: "DealerEdit" });
              }else {
                window.localStorage.setItem('AccountEdit', JSON.stringify(this.Username))
                this.$router.push({ name: "AccountEdit" });
              }
            }else {
              if(key === 'password') {
                this.$router.push({ name: "passwordEdit" });
              }else {
                window.localStorage.removeItem('project');
                this.$router.push({ name: "ProjectList" });
              } 
            }
          }
        }
      }
    },
    PC() {
      this.isMobile = true
    }
  },
};


</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.el-tabs--border-card{
  border:0 !important
}

#devicetab .el-tabs__header{
  background: #000000 !important;
  border-bottom:0  !important;
}

.el-tabs--border-card>.el-tabs__header .el-tabs__item{
border-radius: 10px 10px 0px 0px !important;
border-bottom: 0 !important;
border: 3px solid #000000 !important;
}

.el-tabs--border-card>.el-tabs__header .el-tabs__item.is-active{
  background: linear-gradient(180deg, #2B2B2B 0%, #000000 100%)  !important;
border: 3px solid #292A2E !important;
border-bottom: 0 !important;
}

#devicetab .el-tabs__content{
  padding:0 !important;
  width:100%;
  height:calc(100% - 39px);
  background:#151515;
  border: 3px solid #292A2E;
}

#devicetab .el-tab-pane{
  width:100%;
  height:100%
}
</style>



// WEBPACK FOOTER //
// src/components/Index.vue